/**
 * Created by andrey on 22.08.17.
 */

const ConfirmExitWindow = CleverappsWindow.extend({
    onWindowLoaded: function (options) {
        options = options || {};
        this.action = options.action || function () {};

        const styles = this.styles = cleverapps.styles.ConfirmExitWindow[options.source] || cleverapps.styles.ConfirmExitWindow;

        const text = this.createText(options);

        const spine = options.spine || bundles.confirmexit_window.jsons.confirmexit_window_json;

        let view, rewardList, breaks;
        if (spine) {
            view = this.createAnimation(spine, options.animationName);
        }

        if (options.reward) {
            rewardList = new RewardsListComponent(options.reward, {
                font: cleverapps.styles.FONTS.WINDOW_TEXT,
                margin: styles.reward.margin
            });
        }

        if (typeof BreakViews !== "undefined" && Game.currentGame && cleverapps.environment.isGameScene()) {
            breaks = new BreakViews();
        }

        const content = new cleverapps.Layout([view, text, breaks, rewardList], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: options.padding || styles.padding
        });

        this._super({
            closeByHardwareBackButton: true,
            title: Messages.get("ConfirmExitWindow.title"),
            name: "confirmexitwindow",
            content,
            buttons: this.getButtons(),
            minWidth: styles.size ? styles.size.width : undefined,
            minHeight: styles.size ? styles.size.height : undefined,
            styles: styles.window
        });

        if (styles.button.exitButtonPosition) {
            this.exitGameButton.setAlignment(styles.button.exitButtonPosition);
        }

        if (styles.button.playButtonPosition) {
            this.playButton.setAlignment(styles.button.playButtonPosition);
        }
    },

    getPerson: function () {
        return {
            role: "hero",
            emotion: "sad"
        };
    },

    createAnimation: function (spine, animationName) {
        const styles = this.styles.view;

        const node = new cc.Node();
        node.setAnchorPoint(0.5, 0.5);
        node.setContentSize(styles);

        const animation = new cleverapps.Spine(spine);
        node.addChild(animation);

        if (animationName) {
            animation.setAnimation(0, animationName, true);
        } else if (animation.hasAnimation("open")) {
            animation.setAnimationAndIdleAfter("open", "idle");
        } else {
            animation.setAnimation(0, "sad", true);
        }

        animation.setAlignment(styles);

        return node;
    },

    createText: function (options) {
        const styles = this.styles;

        let message = options.text || Messages.get("AreYouSure");
        if (cleverapps.environment.isGameScene() && ["merge", "merge2"].includes(cleverapps.config.type)) {
            if (Game.currentGame.useLives()) {
                message = Messages.get("ConfirmExitWindow.message");
            }
            if (Game.currentGame.level.isBonusRound()) {
                message = Messages.get("ConfirmExitWindow.BonusRound.message");
            }
        }

        const text = cleverapps.UI.generateOnlyText(message, cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setAnchorPoint(0.5, 0.5);
        text.setDimensions(styles.text.width, 0);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.fitTo(undefined, styles.text.height);

        return text;
    },

    getButtons: function () {
        const styles = this.styles;

        const button = this.playButton = new cleverapps.UI.Button({
            text: Messages.get("PlayOn"),
            onClicked: function () {
                this.close();
            }.bind(this),
            width: styles.button.width,
            height: styles.button.height
        });

        const exitButton = this.exitGameButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_red,
            text: Messages.get("Exit"),
            onClicked: function () {
                this.exitConfirmed = true;
                this.close();
            }.bind(this),
            width: styles.button.width,
            height: styles.button.height
        });

        return [exitButton, button];
    },

    onClose: function () {
        if (this.exitConfirmed) {
            this.action();
        }
    },

    listBundles: function () {
        return ["confirmexit_window"];
    }
});

ConfirmExitWindow.SOURCES = {};

ConfirmExitWindow.SOURCES.OCTOPUS_HUNT = 1;
ConfirmExitWindow.SOURCES.EXIT_APP = 2;

cleverapps.styles.ConfirmExitWindow = {
    margin: 20,

    padding: {
        bottom: 40
    },

    view: {
        width: 400,
        height: 400,

        x: { align: "center" },
        y: { align: "center" }
    },

    text: {
        width: 500
    },

    button: {
        width: 300,
        height: 100
    },

    reward: {
        margin: {
            x: 100
        }
    }
};

cleverapps.styles.ConfirmExitWindow[ConfirmExitWindow.SOURCES.OCTOPUS_HUNT] = cleverapps.overrideStyles(cleverapps.styles.ConfirmExitWindow, {
    size: {
        width: 915,
        height: 960
    },
    button: {
        width: 295,
        height: 95,
        exitButtonPosition: {
            x: {
                align: "right",
                dx: -51
            },
            y: {
                align: "bottom",
                dy: 10
            }
        },
        playButtonPosition: {
            x: {
                align: "left",
                dx: 51
            },
            y: {
                align: "bottom",
                dy: 10
            }
        }
    },
    view: {
        x: {
            align: "center"
        },
        y: {
            align: "center",
            dy: 6
        }
    },
    margin: 49,
    window: {
        margin: 70
    }
}, true);
